// extracted by mini-css-extract-plugin
export var conversationListItem = "_ws-2";
export var fullBleedList = "_ws-3";
export var messageText = "_ws-1";
export var previewText = "_ws-0";